import React, { createContext, useState } from 'react';

export const DeleteContext = createContext();

export const DeleteProvider = ({ children }) => {
  const [toDelete, setToDelete] = useState([]);
  return <DeleteContext.Provider value={[toDelete, setToDelete]}>{children}</DeleteContext.Provider>;
};
